// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WinBackPing-cls1___d356d98d5830087ab21{/*!*/}.WinBackPing-cls2___377982713ea3193e3b5{padding:0;white-space:nowrap;display:flex;justify-content:center}@media screen and (min-width: 950px){.WinBackPing-cls2___377982713ea3193e3b5{padding:10px 20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "WinBackPing-cls1___d356d98d5830087ab21",
	"cls2": "WinBackPing-cls2___377982713ea3193e3b5 WinBackPing-cls1___d356d98d5830087ab21"
};
export default ___CSS_LOADER_EXPORT___;
